module.exports = __webpack_public_path__ + "static/media/single-booth.56ca88dd.png";